module.exports = __webpack_public_path__ + "static/media/AntiTheft_Device_2.2c2f1d0b.png";